
import TextTitle from 'widget-components/components/TextTitle/TextTitle.vue'
import TextPlain from 'widget-components/components/TextPlain/TextPlain.vue'
import TextCopiable from 'widget-components/components/TextCopiable/TextCopiable.vue'
import GraphicImage from 'widget-components/components/GraphicImage/GraphicImage.vue'
import ActionButton from 'widget-components/components/ActionButton'
import DisplayDocument from 'widget-components/components/DisplayDocument/DisplayDocument.vue'
import Divider from 'widget-components/components/Divider'
import EmptySpace from 'widget-components/components/EmptySpace'
import InputCheckbox from 'widget-components/components/InputCheckbox'
import InputCheckboxList from 'widget-components/components/InputCheckboxList'
import InputConsentList from 'widget-components/components/InputConsentList'
import InputCountry from 'widget-components/components/InputCountry'
import InputCountryV2 from 'widget-components/components/InputCountryV2/InputCountry.vue'
import InputDate from 'widget-components/components/InputDate'
import InputDateV2 from 'widget-components/components/InputDateV2/InputDate.vue'
import InputDateTime from 'widget-components/components/InputDateTime'
import InputDateTimeV2 from 'widget-components/components/InputDateTimeV2/InputDateTime.vue'
import InputDigit from 'widget-components/components/InputDigit'
import InputDocument from 'widget-components/components/InputDocument'
import InputFile from 'widget-components/components/InputFile/InputFile.vue'
import InputDropdown from 'widget-components/components/InputDropdown'
import InputDropdownV2 from 'widget-components/components/InputDropdownV2/InputDropdown.vue'
import InputEmail from 'widget-components/components/InputEmail'
import InputEmailV2 from 'widget-components/components/InputEmailV2/InputEmail.vue'
import InputNumber from 'widget-components/components/InputNumber'
import InputNumberV2 from 'widget-components/components/InputNumberV2/InputNumber.vue'
import InputPhoneNumber from 'widget-components/components/InputPhoneNumber/InputPhoneNumber.vue'
import InputPhoneNumberV2 from 'widget-components/components/InputPhoneNumberV2/InputPhoneNumber.vue'
import InputRadio from 'widget-components/components/InputRadio/InputRadio.vue'
import InputSlider from 'widget-components/components/InputSlider'
import InputText from 'widget-components/components/InputText'
import InputText2 from 'widget-components/components/InputTextV2/InputText.vue'
import ListView from 'widget-components/components/ListView'
import ProgressBar from 'widget-components/components/ProgressBar'
import SelectionList from 'widget-components/components/SelectionList/SelectionList.vue'
import Stepper from 'widget-components/components/Stepper'
import Container from 'widget-components/components/Container/Container.vue'
import TabbedContainer from 'widget-components/components/TabbedContainer/TabbedContainer.vue'
import Toggle from 'widget-components/components/Toggle/Toggle.vue'
import InputTextArea from 'widget-components/components/InputTextarea/InputTextarea.vue'
import InputTextAreaV2 from 'widget-components/components/InputTextareaV2/InputTextarea.vue'
import RepeatableContainer from 'widget-components/components/RepeatableContainer/RepeatableContainer.vue'
import ErrorText from 'widget-components/components/ErrorText/ErrorText.vue'
import CheckTrigger from 'widget-components/components/InputCheckbox/CheckTrigger.vue'
import InputConsent from 'widget-components/components/InputConsent/InputConsent.vue'
import InputFileUpload from 'widget-components/components/InputFileUpload/InputFileUpload.vue'
import Position from 'widget-components/components/Position/Position.vue'
import Navigation from 'widget-components/components/Navigation/Navigation.vue'

export default {
    ActionButton,
    EmptySpace,
    ErrorText,
    GraphicImage,
    CheckTrigger,
    InputCheckbox,
    InputCheckboxList,
    Toggle,
    InputConsent,
    InputConsentList,
    InputDate,
    InputDateV2,
    InputDateTime,
    InputDateTimeV2,
    InputDigit,
    InputFileUpload,
    InputFile,
    InputDocument,
    InputDropdown,
    InputDropdownV2,
    InputEmail,
    InputEmailV2,
    InputNumber,
    InputNumberV2,
    InputPhoneNumber,
    InputPhoneNumberV2,
    InputRadio,
    InputSlider,
    InputText,
    InputText2,
    InputTextArea,
    InputTextAreaV2,
    Position,
    SelectionList,
    TextCopiable,
    TextPlain,
    TextTitle,
    DisplayDocument,
    ProgressBar,
    Stepper,
    Divider,
    ListView,
    Container,
    InputCountry,
    InputCountryV2,
    RepeatableContainer,
    TabbedContainer,
    Navigation,
}
